import React, { useState } from "react";
import styles from "../Casefile.module.scss";
import CloseButton from "./CloseButton";

import { Link } from "@reach/router";

function Seagull(props) {
  const [bacteriaNo, setBacteriaNo] = React.useState(0);

  if (bacteriaNo === 0) {
    return (
      <div className={styles.queryBox}>
        <CloseButton setSelected={props.setSelected} />
        <div className={styles.questions}>
          <p>
            "You find the Seagull on the roofs of Bold Street, you notice it is
            eating something. "Of course" you mutter under your breath, which
            causes the seagull to turn around. Quickly you blurt out "Oh, hey!"
          </p>
          <p>
            The seagull replies, "Hey, uh... I'm just finishing this, will be
            with you in a sec dude." and then proceeds to scoff a whole Nabzy's
            burger meal deal, package included. "I feel better now, how can I
            help you dude?" says the Seagull. You are really grossed out.
          </p>{" "}
          <p>
            <button
              onClick={(event) => {
                setBacteriaNo(1);
              }}
            >
              What are you up to?
            </button>
          </p>{" "}
          <p>
            <button
              onClick={(event) => {
                setBacteriaNo(3);
              }}
            >
              Have you had any incidents in Liverpool?
            </button>
          </p>
        </div>
      </div>
    );
  }
  if (bacteriaNo === 1) {
    return (
      <div className={styles.queryBox}>
        <CloseButton setSelected={props.setSelected} />
        <div className={styles.questions}>
          <p>
            "Ah. Well, I clean up the human food they seem to not eat. Also, a
            bit of food that they are eating... But we don't talk about that..."
            the Seagull is not making itself more likeable. "I stay around here
            and pray to the winds I get the odd sausage roll dude. Especially
            those vegan ones, they are stunning."
          </p>

          <button
            onClick={(event) => {
              setBacteriaNo(2);
            }}
          >
            {" "}
            I'm pretty sure the Pigeon won't be happy about this
          </button>
        </div>
      </div>
    );
  }
  if (bacteriaNo === 2) {
    return (
      <div className={styles.queryBox}>
        <CloseButton setSelected={props.setSelected} />
        <div className={styles.questions}>
          <p>
            "Oh dude! I forgot about that important meeting about some weird
            bacteria taking over! I better run... though I hate flying on an
            empty stomach!" The Seagull is trying to stand up to start flying.
            "Dude, would you do me a maaassssiiiivvveee favour? Would you please
            take over my Incident Marker duties?? Oh thanks you're a lifesaver
            mate! See you later!" And before you can say No, you're by yourself
            on top of the roof.
          </p>
          <p>Well, suppose you'd better place some Incident Markers...</p>
        </div>
      </div>
    );
  }
  if (bacteriaNo === 3) {
    return (
      <div className={styles.queryBox}>
        <CloseButton setSelected={props.setSelected} />
        <div className={styles.questions}>
          <p>
            "All the time, I clean up most of the mess that humans leave. Of
            course those ungrateful human-dodos are on the verge of extinction!
            They look at me and think of me as a plague! If they hadn't brought
            their delicious fast food in the first place we wouldn't be obsessed
            with it!" The Seagull needs professional help. "That being said, I'm
            hungry do you have anything in there for me?" The Seagull looks
            desperate.
          </p>

          <p>
            You try and reach for your pockets, but you've just realised you're
            a non-human now!
          </p>
          <p>
            {" "}
            <button
              onClick={(event) => {
                setBacteriaNo(4);
              }}
            >
              What about your incident markers?
            </button>
          </p>
        </div>
      </div>
    );
  }
  if (bacteriaNo === 4) {
    return (
      <div className={styles.queryBox}>
        <CloseButton setSelected={props.setSelected} />
        <div className={styles.questions}>
          <p>
            "Oh yeah I should be writing those... I'm just too hungry to think
            if I'm honest, dude. I don't know, I guess I need to step up and
            start making points for our folk!"
          </p>

          <p>
            {" "}
            You are so disappointed. Seeing the Seagull slacking makes you want
            to work harder for the birds!
          </p>

          <p>
            {" "}
            <button
              onClick={(event) => {
                setBacteriaNo(2);
              }}
            >
              I'm pretty sure the Pigeon won't be happy about this
            </button>
          </p>
        </div>
      </div>
    );
  }
}

export default Seagull;
